import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import api from "../../../api/api";


const PermModelName = (item) => {
  return (
    <div className="flex items-center gap-1">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        role="img"
        width="1em"
        height="1em"
        preserveAspectRatio="xMidYMid meet"
        viewBox="0 0 24 24"
      >
        <path
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeWidth={2}
          d="M20 12H4"
        />
      </svg>
      <svg
        id=""
        className="h-6 w-6 text-[#F8D775]"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        role="img"
        width="1em"
        height="1em"
        preserveAspectRatio="xMidYMid meet"
        viewBox="0 0 1024 1024"
      >
        <path
          fill="currentColor"
          d="M928 444H820V330.4c0-17.7-14.3-32-32-32H473L355.7 186.2a8.15 8.15 0 0 0-5.5-2.2H96c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h698c13 0 24.8-7.9 29.7-20l134-332c1.5-3.8 2.3-7.9 2.3-12c0-17.7-14.3-32-32-32zm-180 0H238c-13 0-24.8 7.9-29.7 20L136 643.2V256h188.5l119.6 114.4H748V444z"
        />
      </svg>
      <p className="text-red-500">{item.model}</p>
    </div>
  );
};


const ListGroup = () => {
  const [groups, setGroups] = useState([]);
  const [delRes, setDelRes] = useState(false)

  useEffect(() => {
    api
      .get("/users/groups/")
      .then((response) => {
        console.log(response.data);
        setGroups(response.data);
      })
      .catch((error) => {
        toast.error("Something went wrong");
      });
  }, [delRes]);

  const handleDel = (id) => {
    api.delete(`/users/groups/${id}/`)
    .then(response=> {
      setDelRes(true)
      toast.success("Deleted successfully")
    }).catch(error=> {
      toast.error("Unable to delete")
    })
  }


  return (
    <div className="w-full justify-center flex  ">
      <div className=" w-[90%]  mt-10 ">
        <h1 className="text-primary-red underline mt-2 text-center text-3xl font-bold lg:!mt-6">
          List Of Group
        </h1>
        {/* <div className='w-full'>
          <div className="flex w-full justify-between">
            <input
              placeholder="Search by name"
              type="search"
              className="my-3 rounded-lg border border-black p-3"
            />

          </div>

        </div> */}
        <div className="overflow-x-auto">
          <table className="border-primary-blue mt-5  w-full border overflow-x-auto text-center">
            <thead className="font-Bree bg-primary-red text-lg font-bold">
              <tr className="">
                <th
                  scope="col"
                  className="border-primary-blue w-[0.5rem] border-2 md:px-6 md:py-4 text-sm font-medium text-white"
                >
                  SN.
                </th>
                <th
                  scope="col"
                  className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
                >
                  Post
                </th>
                <th
                  scope="col"
                  className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
                >
                  Autority
                </th>

                <th
                  scope="col"
                  className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
                >
                  Action
                </th>
              </tr>
            </thead>

            <tbody>
              {
                groups.map((item, index)=> {
                  return (
                    <tr className="border-primary-blue border-2 bg-white" key={index}>
                    <td className="border-primary-blue  whitespace-nowrap border-2  text-sm font-light text-primary-blue">
                      {index+1}
                    </td>
                    <td className="border-primary-blue whitespace-nowrap border-2 md:px-6 md:py-4 text-sm font-light text-primary-blue">
                      {/* Manager */}
                      {item.name}
                    </td>
    
                   
                    <td className="border-primary-blue whitespace-nowrap border-2 md:px-6 md:py-4 text-sm font-light text-primary-blue">
                      {item?.permissions.map((perm, i) => {
                      return (
                        <div key={i}>
                          {i - 1 >= 0
                            ? perm.model === item.permissions[i - 1].model
                              ? ""
                              : PermModelName(perm)
                            : PermModelName(perm)}


                             <div className="flex justify-start pl-5 items-center gap-2">
                              <svg
                                className="h-5 w-5"
                                xmlns="http://www.w3.org/2000/svg"
                                aria-hidden="true"
                                role="img"
                                preserveAspectRatio="xMidYMid meet"
                                viewBox="0 0 24 24"
                              >
                                <g
                                  fill="#fff"
                                  stroke="#EE1D23"
                                  strokeLinejoin="round"
                                  strokeWidth={2}
                                >
                                  <path
                                    strokeLinecap="round"
                                    d="M4 4v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8.342a2 2 0 0 0-.602-1.43l-4.44-4.342A2 2 0 0 0 13.56 2H6a2 2 0 0 0-2 2Zm5 9h6m-6 4h3"
                                  />
                                  <path d="M14 2v4a2 2 0 0 0 2 2h4" />
                                </g>
                              </svg>
                              <label  htmlFor="">{perm.name}</label>
                              <input
                                className="form-check-input  my-1 h-4 w-4 cursor-pointer appearance-none rounded-full border border-blue-900 bg-yellow-300 bg-contain bg-center bg-no-repeat align-top transition duration-200 checked:border-blue-600 checked:bg-blue-600 focus:outline-none"
                                type="checkbox"
                                defaultValue=""
                                id="flexCheckDefault3"
                              />
                            </div>
                        </div>
                      );
                    })}

                    </td>

                    <td className="border-primary-blue w-10 whitespace-nowrap border-2 md:px-6 md:py-4 text-sm font-light text-gray-900">
                      <div className=" flex gap-1 ">
                        
                        <button 
                        onClick={()=> handleDel(item.id)}
                        className="bg-red-400 rounded-xl p-1 text-white hover:bg-primary-blue">
                          Delete
                        </button>
                      </div>
                    </td>
                  </tr>
                  )
                })
              }
            

             
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ListGroup;
